import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Colors } from '../../../types/colors';

interface IProps {
  id?: string;
  children: ReactNode;
  level?: 'hero' | '1' | '2' | '3' | '4';
  color?: Colors;
  className?: string;
  style?: React.CSSProperties;
}

// 700px is the `mobile` breakpoint, which the old media queries matched exactly.
const LEVEL = {
  hero: 'text-[5.375rem] leading-[1.2] font-black tracking-[-0.02em] max-mobile:text-[3.5rem] max-mobile:leading-[1.1] max-mobile:tracking-[-0.01em]',
  '1': 'text-[3.5rem] leading-[1.1] font-black tracking-[-0.01em] max-mobile:text-[3rem]',
  '2': 'text-[3rem] leading-[1.1] font-black tracking-[-0.01em]',
  '3': 'text-[2rem] leading-[1.1] font-black',
  '4': 'text-[1.5rem] leading-[1.1] font-black',
};

const TAG = {
  hero: 'h1',
  '1': 'h1',
  '2': 'h2',
  '3': 'h3',
  '4': 'h4',
} as const;

const Headline = ({
  id,
  children,
  level = 'hero',
  color = 'blue',
  className,
  ...props
}: IProps): ReactElement => {
  const HeadlineEl = TAG[level];

  return (
    <HeadlineEl
      id={id}
      className={twMerge(
        'headline',
        LEVEL[level],
        `text-type-${color}`,
        className
      )}
      {...props}>
      {children}
    </HeadlineEl>
  );
};

export default Headline;
